/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const changeZakatDatePostRequestSchema = z.object({
  value: z.string(),
});
